class CopyUrl {
  constructor(element) {
    this.button = element;
    this.url = this.button.dataset.copyUrlButton;
    this.copyToClipBoard();
  }

  copyToClipBoard() {
    this.button.addEventListener("click", () => {
      navigator.clipboard.writeText(this.url);
      const tooltip = this.button.parentNode;
      tooltip.classList.add('active');
      setTimeout(function(){tooltip.classList.remove('active')}, 10000);
    });
  }
}

const copyUrlButtons = document.querySelectorAll('[data-copy-url-button]');

copyUrlButtons.forEach(  (button) => {
  button.CopyUrl = new CopyUrl(button);
});
